import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  records: [],
};

export const applicationsSlice = createSlice({
  name: "applications",
  initialState,
  reducers: {
    setApplications: (state, action) => {
      state.records = action.payload;
    },
    updateApplications: (state, action) => {
      // TODO this must update the server as well?
      //  not really! the server must be updated through api calls
      //  perhaps the api call can then trigger this to update the store!
      const row = action.payload;
      return {
        ...state,
        records: state.records.map((thisRow) => {
          return thisRow._id === row._id ? row : thisRow;
        }),
      };
    },
    clearApplications: (state) => {
      state.records = [];
    },
  },
});

export const { setApplications, updateApplications, clearApplications } =
  applicationsSlice.actions;
export default applicationsSlice.reducer;
